import {defineStore} from 'pinia'
import router from "@/router"
export const RouteStore = defineStore('RouteStore', {
  state: () => {
    return {
      routes: new Map(),
      hkRouterParams: {},
      mfaState: null,
      loading: false
    };
  },
  actions: {
    setLoadingTrue(){
      this.loading = true
    },
    setLoadingFalse(){
      this.loading = false
    },
    setRouteParams(payload){
      if(payload){
        this.hkRouterParams = payload?.params || {}
      } else {
        this.hkRouterParams = {}
      }
    },
    hkRouterPush(payload) {
      return new Promise((resolve,reject)=>{
        this.setRouteParams(payload);
        router.push(payload).then((res)=>{
          resolve(res)
        }).catch(e=>{
            reject(e)
        });
      })

    },
    hkRouterReplace(payload) {
      this.setRouteParams(payload);
      router.replace(payload);
    },
  }
})
